module.exports = __webpack_public_path__ + "static/img/080.4b76db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/080.png
// module id = iHlQ
// module chunks = 0